import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import ReactSwipe from 'react-swipe';

import { CarouselImage } from '../carousel-image';
import styles from './ImageCarouselMobile.css';
import { ProductStore } from '../stores/ProductStore';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

class ImageCarouselMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
    this._updateIndex = this._updateIndex.bind(this);
  }

  _updateIndex(index) {
    this.setState({
      currentIndex: index,
    });
  }

  render() {
    const { product: { images } } = ProductStore;
    if (!images.length) {
      return null;
    }
    const reactSwipeOptions = {
      auto: 3000,
      callback: this._updateIndex,
    };
    return (
      <div className={this.props.className}>
        <ReactSwipe swipeOptions={reactSwipeOptions}>
          {
            images.map(image => (
              <div className={styles.imageContainer} key={image}>
                <div className={styles.imageFlex}>
                  <CarouselImage
                    alt=""
                    className={styles.image}
                    src={image}
                  />
                </div>
              </div>
            ))
          }
        </ReactSwipe>
        <div className={styles.markerContainer}>
          {
            images.map((image, index) => (
              <div
                className={[
                  styles.marker,
                  index === this.state.currentIndex ? styles.current : '',
                ].join(' ')}
                key={image}
              />
            ))
          }
        </div>
      </div>
    );
  }
}

ImageCarouselMobile.propTypes = IPropTypes;
ImageCarouselMobile.defaultProps = defaultProps;

const WrappedImageCarouselMobile = observer(ImageCarouselMobile);

export { WrappedImageCarouselMobile as ImageCarouselMobile };



// WEBPACK FOOTER //
// ./src/pages/product-detail/image-carousel-mobile/ImageCarouselMobile.jsx